<template>
  <el-dialog
    v-if="visible"
    v-el-drag-dialog
    :visible.sync="visible"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    top="4vh"
    width="55%"
    center
  >
    <dialog-header
      slot="title"
      :title="!isEdit?$t('carManagement.createAndUpdate.create'):$t('carManagement.createAndUpdate.update')"
      :icon="!isEdit?'icon-common-add':'icon-common-edit'"
      @close="closeDialog"
    />
    <div style="height: 70vh" class="default-container-class">
      <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
        <vue-linetitle
          :icon-config="{icon:'car-infomation'}"
          :title="`${$t('carManagement.createAndUpdate.title1')}`"
        >
          <el-form ref="vehicleForm"
            size="mini"
            :model="formInfo"
            label-suffix="："
            :show-message="false"
            :label-width="$t('carManagement.createAndUpdate.leftLabelWidth')"
          >
            <el-row>
              <el-col :span="12">
                <!-- 车牌号 -->
                <el-form-item :label="$t('public.licensePlate')" prop="licensePlate" required>
                  <el-input
                    v-model="formInfo.licensePlate"
                    maxlength="10"
                    clearable
                    :placeholder="$t('public.licensePlate')"
                    />
                </el-form-item>
                <!-- 区域(府) -->
                <el-form-item :label="$t('carManagement.area')" prop="areaId" required>
                  <el-select
                    v-model="formInfo.areaId"
                    filterable
                    clearable
                    :placeholder="$t('carManagement.area')"
                    >
                    <el-option
                      v-for="item in areas"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaId"
                      />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="cell-class license-content-style">
                <vue-licenseplate
                  :licensepalte="formInfo.licensePlate"
                  :area="getArea(formInfo.areaId)"
                />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :label="$t('carManagement.createAndUpdate.category')"
                  prop="modelId"
                  required
                  >
                  <el-cascader
                    @change="changeCategory"
                    ref="myCascader"
                    filterable
                    clearable
                    v-model="formInfo.modelId"
                    :options="models"
                    :props="propConfig"
                  ></el-cascader>
                </el-form-item>
                <el-form-item
                  :label="$t('carManagement.series')"
                  v-show="showCarSettings"
                >{{formInfo.carSeries}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('carManagement.brand')"
                  v-show="showCarSettings"
                >{{formInfo.carBrand}}</el-form-item>
                <el-form-item
                  :label="$t('carManagement.model')"
                  v-show="showCarSettings"
                >{{formInfo.carModel}}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item 
                  :label="$t('carManagement.fuelType')" 
                  prop="fuelTypeId"
                  required
                  >
                  <el-select
                    v-model="formInfo.fuelTypeId"
                    filterable
                    clearable
                    :placeholder="$t('carManagement.fuelType')"
                    >
                    <el-option
                      v-for="item in fuels"
                      :key="item.id"
                      :label="item.fuelType"
                      :value="item.id"
                      />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('carManagement.regVin')">
                  <el-input
                    v-model="formInfo.vinNo"
                    maxlength="20"
                    filterable
                    clearable
                    :placeholder="$t('carManagement.regVin')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isEdit">
              <el-col :span="12">
                <el-form-item 
                  :label="$t('carManagement.ecuVin')" 
                  >
                  {{formInfo.ecuVin}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('carManagement.ecuVinRefreshTime')">
                  {{formInfo.ecuVinRefreshTime}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </vue-linetitle>
        <vue-linetitle
          :icon-config="{icon:'car-OBD'}"
          :title="`${$t('carManagement.createAndUpdate.title3')}`"
        >
          <el-form ref="obdForm"
            size="mini"
            :model="formInfo"
            label-suffix="："
            :label-width="$t('carManagement.createAndUpdate.leftLabelWidth')"
            >
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('public.obdCode')" prop="barCode">
                  <el-input v-model="formInfo.barCode" maxlength="10" :placeholder="$t('public.obdCode')" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('public.sim')" prop="sim">
                  <el-input v-model="formInfo.sim" maxlength="50" :placeholder="$t('public.sim')" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </vue-linetitle>
        <vue-linetitle
          :icon-config="{icon:'car-other'}"
          :title="`${$t('carManagement.createAndUpdate.title4')}`">
          <el-form
            size="mini"
            :model="formInfo"
            label-suffix="："
            :label-width="$t('carManagement.createAndUpdate.leftLabelWidth')"
            >
            <el-form-item :label="$t('public.note')" >
              <el-input 
                type="textarea"
                v-model="formInfo.remark"
                maxlength="200"
                :placeholder="$t('public.note')"
                />
            </el-form-item>
          </el-form>
        </vue-linetitle>
      </el-scrollbar>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="handleCancel"
      >{{$t('public.cancel')}}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import {
  addVehicleUrl,
  updateVehicleUrl
} from '@/api/system/company'
import resolve from '@/api/resolve'
export default {
  name: 'AddUpdateDialog',
  mixins: [partialForm],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    areas() {
      return this.$store.state.cache.areas
    },
    models() {
      return this.$store.getters.cascaderModels
    },
    fuels() {
      return this.$store.state.cache.fuels
    }
  },
  data() {
    return {
      formInfo: {},
      showCarSettings: false,
      propConfig: {
        label: 'name',
        value: 'id',
        children: 'children',
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.isEdit) {
          // eslint-disable-next-line no-unused-vars
          const {
            seriesId,
            brandId,
            areaId,
            modelId,
            ...myData
          } = this.data
          this.formInfo.areaId = areaId
          this.formInfo.modelId = [brandId, seriesId, modelId]
          this.$nextTick(() => {
            this.changeCategory(this.formInfo.modelId)
          })
          this.formInfo = { ...this.formInfo, ...myData }
          this.showCarSettings = true
        }
      }
    }
  },
  methods: {
    changeCategory(item) {
      if (item.length === 3) {
        let nameArry = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
        let arr = ['carBrand', 'carSeries', 'carModel']
        for (let i = 0; i < arr.length; i++) {
          this.$set(this.formInfo, arr[i], nameArry[i])
        }
        this.showCarSettings = true
      }
    },
    // 关闭
    closeDialog() {
      this.$emit('update:visible', false)
      this.formInfo = {}
      this.showCarSettings = false
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 提交
    handleSubmit() {
      this.$refs.vehicleForm.validate((valid) => {
        if (valid) {
          const { ...postData } = this.formInfo
          postData.modelId = postData.modelId[postData.modelId.length - 1]
          this._submit(postData)
        }
      })
    },
    //根据isedit提交
    _submit(postData) {
      if (!this.isEdit) {
        this._createCar(postData)
      } else {
        this._updateCar(postData)
      }
    },
    // 新增
    _createCar(postData) {
      this.$http.post(addVehicleUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000,
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    _updateCar(postData) {
      this.$http.put(resolve(updateVehicleUrl, this.data.carId), postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000,
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    },
    getArea(areaId) {
      if (areaId) {
        const filter = this.areas.filter(area => area.areaId === areaId)[0]
        if (filter) {
          return filter.areaName
        }
      }
      return ''
    },
  },
}
</script>

<style lang='scss'>
.cell-class {
  display: flex;
  padding-left: 60px;
  .license-other {
    margin-top: 14px !important;
    height: 43px;
  }
  .el-radio-group {
    margin-left: 10px;
    width: 80px;
    .el-radio {
      padding: 10px 0 0 10px;
    }
  }
}
</style>
